import {
    login
} from "./config";

export default { 
    login: (email, password) => {
        return login.post("/v1/login?"+"email="+email+"&password="+password)
    }
}
